import React from "react";
import classNames from "classnames";
import {
  GOVGR_TABS__LIST_ITEM,
  GOVGR_TABS__LIST_ITEM_SELECTED,
} from "../../conf/styles/GovGrTabs";

const GrGovTab = ({ activeTab, label, value, onClick }) => {
  // Check if particular tab is selected and returns true or false
  const IsSelectedTabActive = activeTab === value;

  // Assign class on tab component based if it's selected or not
  let selectedTabClasses = classNames(GOVGR_TABS__LIST_ITEM, {
    [`${GOVGR_TABS__LIST_ITEM_SELECTED}`]: IsSelectedTabActive,
  });

  return (
    <li className={selectedTabClasses} role="presentation" onClick={onClick}>
      <div
        className="govgr-tabs__tab"
        id={activeTab}
        role="tab"
        aria-controls="past-week"
        aria-selected="false"
        tabIndex={value}
      >
        {label}
      </div>
    </li>
  );
};

export default GrGovTab;
